export default __webpack_public_path__ + "static/media/ddsu5168_2p_rs485_master_4p.c1878152.jpg";